import type { OrderDetailsOrderLine } from '@/types/orderDetailsOrder';

import { ProductType } from '@/lib/const';
import { getProductType } from '@/lib/product';

import { isReturnableLine } from './returnableOrderLine';

export const WITHDRAWAL_EXCLUDED_PRODUCT_TYPE_SLUGS = [
  ProductType.Digital,
] as const;

export type WithdrawalExcludedProductTypeSlug =
  (typeof WITHDRAWAL_EXCLUDED_PRODUCT_TYPE_SLUGS)[number];

const withdrawalExcludedProductTypeSlugs = new Set<string>(
  WITHDRAWAL_EXCLUDED_PRODUCT_TYPE_SLUGS,
);

export function isWithdrawalExcludedProductType(
  slug: string | null | undefined,
): boolean {
  if (!slug) return false;
  return withdrawalExcludedProductTypeSlugs.has(slug);
}

export function isWithdrawalExcludedOrderLine(
  line: OrderDetailsOrderLine,
): boolean {
  const slug = getProductType(line?.variant?.product?.productType);
  return isWithdrawalExcludedProductType(slug);
}

export function hasWithdrawalActionableLines(
  lines: ReadonlyArray<OrderDetailsOrderLine>,
): boolean {
  return lines.some(
    (line) => isReturnableLine(line) && !isWithdrawalExcludedOrderLine(line),
  );
}
